export default __webpack_public_path__ + "static/media/phone-icon.254c4835.svg";